import { createApp } from 'vue'
import FButton from '~/js/components/button'
import FPaginator from '~/js/components/paginator'
import FProductCard from '~/js/components/productCard'
import { getItemsFromIds } from '~/js/helpers/getProducts'
import {
  ensureCollectionProductIndex,
  getCachedCollectionProductTotal,
} from '~/js/helpers/storefront/collectionProducts'
import { getParam } from '~/js/helpers/url-helper'
import './articles'
import './catalog'
import './itemFinder'

const ID = 'js-collection'
const HITS_PER_PAGE = 48

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById(ID)
  if (!element) return
  const collectionId = element.dataset.collectionId
  const storefrontAccessToken = element.dataset.storefrontAccessToken
  const page = Math.max(Number(getParam('page') || '1'), 1)

  if (!storefrontAccessToken) return

  createApp({
    name: 'TemplatesCollection',
    data() {
      return {
        itemPerPage: HITS_PER_PAGE,
        hasNextPage: false,
        pagination: {},
        products: [],
        total: 0,
      }
    },
    components: {
      FButton,
      FPaginator,
      FProductCard,
    },
    created() {
      this.search()
    },
    methods: {
      async search() {
        try {
          const start = (page - 1) * HITS_PER_PAGE
          const end = start + HITS_PER_PAGE
          const productIndex = await ensureCollectionProductIndex({
            collectionId,
            storefrontAccessToken,
            minimumVisibleCount: end,
          })
          const pageProductIds = productIndex.ids.slice(start, end)
          const products = await getItemsFromIds(pageProductIds)

          this.products = products
          this.hasNextPage = productIndex.hasNextPage
          this.itemPerPage = HITS_PER_PAGE
          this.total = getCachedCollectionProductTotal(productIndex)
        } catch (e) {
          console.error(e)
        }
      },
      rankNumber(index) {
        return (page - 1) * HITS_PER_PAGE + index + 1
      },
    },
  }).mount(element)
})
